var HeroCarousel = {
	init:function(){
	
		var hero_carousel = $('.heroes .hero-carousel').slick({
			centerMode: false,
			centerPadding: 0,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 3000,
			infinite: true,
			speed: 500,
			fade: true,
			draggable: false,
			cssEase: 'linear',
			arrows:true,
			dots:true,			 
			appendDots: $('.heroes .carousel-dots'),
		});
		
		hero_carousel.on('afterChange', function() {
			var index = Number($('.heroes .hero-carousel .slick-slide.slick-current').data('slick-index'))+1;
			if (index < 10) {
				index = "0" + index;
			}
			
			$('.heroes  .counter .current').html(index);

			$('.yt_player_iframe').each(function() {
			  this.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
			});
		});

		$('.heroes .slick-prev').click(function(){
			hero_carousel.slick('slickPrev');
			return false;
		});

		$('.heroes .slick-next').click(function(){
			hero_carousel.slick('slickNext');
			return false;
		});
	}
};

function updateActive360 (frame, args) {
	var target = $(args[0].target).data('target');
	$('.rotate_pager[data-target="'+target+'"] ul li').removeClass('active');
	$('.rotate_pager[data-target="'+target+'"] ul li[data-index="'+frame+'"]').addClass('active');       
	$('.'+target+' .img').addClass('hidden');
	$('.'+target+' .img[data-index="'+frame+'"]').removeClass('hidden');
}
